/* Bloomup Size Guide drawer — designer garment charts 8 Sep 2026 + workbook body charts (inches; cm derived x2.54) */
(function () {
  if (window.BloomupSizeChart) return;

  var NOTE_D = 'Finished-garment measurements. "Half" = laid flat, measured across one side. Minor variations (±0.5 in) may occur due to fabric and washing.';
  var NOTE_X = 'Garment measurements, measured flat on the product. Minor variations (±0.5 in) may occur due to fabric and washing.';
  var M4 = ['0-6M', '6-12M', '12-18M', '18-24M'];
  function T(label, cols, sizes, data) { return { label: label, cols: cols, rows: sizes.map(function (s, i) { return [s, data[i]]; }) }; }

  var TOP5 = ['Body Length', 'Chest Half', 'Sleeve Length (Half)', 'Shoulder', 'Waist Half'];
  var ONE7 = ['Body Length', 'Chest Half', 'Waist Half', 'Sleeve Length', 'Shoulder Strap Length', 'Hip Around', 'Inseam'];
  var SET_TOP = ['Upper Length', 'Chest Half', 'Waist Half', 'Sleeve Length', 'Shoulder Length'];
  var SET_BOT3 = ['Hip Around', 'Inseam', 'Bottom Length'];
  var BOT4 = ['Length', 'Waist Half', 'Inseam', 'Hip'];
  var Y4 = ['2Y', '3Y', '4Y', '5Y'];

  var CHARTS = {
    tshirt_boy: { title: 'Boys T-Shirt', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', TOP5, M4, [[11.5, 9, 3.7, 7.7, 9], [12, 9.5, 4, 8, 9.5], [13, 10.25, 4.1, 8.5, 10], [14, 10.5, 4.25, 9, 10.25]]) ] },
    tshirt_girl: { title: 'Girls T-Shirt', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', TOP5, M4, [[11.5, 9, 3.5, 8, 8.5], [12.1, 9.5, 3.5, 9, 9], [12.5, 10, 4, 9, 9.5], [13.5, 11, 4.1, 10, 10.5]]) ] },
    top_girl: { title: 'Girls Top', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', TOP5, M4, [[11.5, 9.5, 2.5, 12, 9], [12, 10, 3, 12.5, 9.5], [13.1, 11, 3.5, 13, 10], [13.5, 12, 4, 13.5, 11]]) ] },
    shirt_boy: { title: 'Boys Shirt', fit: 'Oversize fit', note: NOTE_D, tables: [
      T('', ['Length', 'Chest Half', 'Sleeve Length (Half)', 'Shoulder', 'Waist Half'], M4.concat(Y4),
        [[12, 11.5, 4, 9, 11], [13, 12, 4, 10, 11.5], [13.5, 12, 4.25, 10.25, 12], [14, 12.25, 4.5, 10.5, 12.25],
         [15, 12.5, 5, 11, 12.5], [16, 12.75, 5, 11.7, 12.75], [17, 13, 5, 12, 13], [18, 14, 5.5, 12.5, 14]]) ] },
    sweatshirt_boy: { title: 'Boys Sweatshirt', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', TOP5, M4, [[12.5, 10, 10, 11.5, 10], [13, 10.5, 11, 12, 10.5], [14, 11, 12, 12.5, 11], [15, 11.5, 13, 13, 11.5]]) ] },
    jacket_boy: { title: 'Boys Jacket', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', TOP5, M4, [[13.5, 13, 1.5, 9, 13], [14, 14, 1.5, 9.5, 14], [15, 14, 1.5, 10.5, 14], [15.5, 15, 1.5, 11, 15]]) ] },
    jacket_girl: { title: 'Girls Jacket', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', TOP5, M4, [[12, 10.75, 10, 8, 10.5], [13, 11.5, 11, 9, 11], [14, 12, 12, 10, 11.5], [15, 12.5, 13, 11, 12]]) ] },
    dress_girl: { title: 'Girls Dress', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', ['Body Length', 'Chest Half', 'Waist Half', 'Sleeve Length', 'Shoulder Strap Length', 'Hip Around'], M4,
        [[15, 10, 10, 4, 8.5, 24], [16, 10.75, 10.5, 4, 8.7, 26], [16.4, 11.25, 11, 4.3, 9.5, 27], [17, 11.5, 11.5, 4.5, 9.7, 28]]) ] },
    pant_boy: { title: 'Boys Pant', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', BOT4, M4, [[14, 8.5, 7.2, 10], [15, 9, 7.3, 10.5], [16, 9.5, 7.5, 11], [17, 10, 8, 11.5]]) ] },
    winterpant_girl: { title: 'Girls Winter Bottom', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', BOT4, M4, [[14, 9, 7.2, 10.5], [16, 9.5, 7.3, 10.75], [17, 10, 7.5, 11], [18, 10.5, 8, 11.5]]) ] },
    shorts_boy: { title: 'Boys Shorts', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', ['Length', 'Waist Relaxed', 'Inseam', 'Hip'], M4, [[7.5, 8.5, 7, 9], [8, 8.75, 7, 10], [9, 9, 7.5, 10.5], [9.25, 9.5, 7.5, 10.75]]) ] },
    shorts_girl: { title: 'Girls Shorts', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', ['Waist Half', 'Bottom Length', 'Inseam', 'Hip'], M4.concat(Y4),
        [[9, 8, 7.5, 22], [9.5, 8.5, 7.5, 23], [10, 9, 7.5, 23.5], [10.5, 9.5, 8, 24], [10.5, 12, 8.5, 25], [11, 14, 8.5, 25], [11.5, 16, 9, 26], [12, 18, 10, 28]]) ] },
    dungaree_boy: { title: 'Boys Dungaree', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', ONE7, M4, [[18, 9.5, 9.5, 3.5, 8.5, 11, 4.5], [19, 10, 10, 3.6, 9, 11.5, 5.5], [20, 11, 11, 4, 9.5, 12, 6], [21, 11.5, 11.5, 4.25, 9.5, 12.5, 6.5]]) ] },
    dungaree_girl: { title: 'Girls Dungaree', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', ONE7, M4, [[14, 9.5, 9.5, 2.7, 8, 10.5, 7], [15, 10, 10, 3, 9, 11, 7.5], [15.5, 10.5, 10.5, 3.5, 9.5, 11.5, 7.5], [17, 11, 11, 3.5, 10, 12, 8]]) ] },
    romper: { title: 'Romper', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', ONE7, M4, [[18, 11.5, 11.5, 3.5, 12.5, 25, 4.5], [19, 12, 12, 4, 13, 26, 5.5], [20.5, 12.5, 12.5, 4, 13.5, 26.5, 6], [21, 13, 13, 4.5, 15, 28, 6.5]]) ] },
    bodysuit: { title: 'Bodysuit', fit: 'Regular fit', note: NOTE_D, tables: [
      T('', ['Body Length', 'Chest Half', 'Waist Half', 'Sleeve Length', 'Shoulder Strap Length', 'Hip Around'], ['0-3M', '3-6M', '6-9M', '9-12M', '12-18M'],
        [[12, 8.5, 8, 3.1, 7.5, 17.5], [14, 9, 8.5, 3.5, 8, 18], [15, 9.5, 9, 3.5, 8, 18.5], [16, 9.75, 9.25, 4, 8.5, 19], [16.5, 10, 9.5, 4.5, 9, 19.5]]) ] },
    set2_boy: { title: 'Boys 2 Pcs Set', fit: 'Regular fit', note: NOTE_D, tables: [
      T('Top', SET_TOP, M4, [[11.25, 10.5, 10, 3.5, 9], [11.75, 11, 10.5, 3.75, 10], [12, 11.5, 11, 4, 10.5], [13.35, 12, 11.5, 4.25, 11]]),
      T('Bottom', ['Hip Around', 'Inseam'], M4, [[22, 7.5], [23, 8.5], [24, 9], [26, 9.5]]) ] },
    set3_boy: { title: 'Boys 3 Pcs Set', fit: 'Regular fit', note: NOTE_D, tables: [
      T('Top', SET_TOP, M4, [[11.2, 10.5, 10, 3.5, 9], [11.75, 11, 10.5, 3.75, 10], [12, 11.5, 11, 4, 10.5], [13.3, 12, 11.5, 4.25, 11]]),
      T('Bottom', SET_BOT3, M4, [[22, 7.5, 8.5], [23, 8.5, 9], [24, 9, 10], [26, 9.5, 10.25]]) ] },
    fullsuit_boy: { title: 'Boys Full Suit Set', fit: 'Regular fit', note: NOTE_D, tables: [
      T('Top', SET_TOP, M4, [[12.5, 10.5, 10, 10, 9], [13, 10.75, 10.25, 10.2, 9.25], [14, 11, 10.5, 11.25, 9.5], [14, 11.5, 11, 11.5, 10]]),
      T('Bottom', SET_BOT3, M4, [[21, 6.5, 15], [22, 6.5, 16], [23, 7, 17], [24, 7, 18]]) ] },
    set_girl: { title: 'Girls 2 Pcs Set', fit: 'Regular fit', note: NOTE_D, tables: [
      T('Top', SET_TOP, M4.concat(Y4), [[11.5, 9.5, 9.25, 3.5, 8], [12, 10, 9.5, 3.75, 9], [12.5, 10.5, 10, 4, 9], [13.5, 11, 11, 4.25, 10],
        [13.5, 11.5, 11, 4.5, 11.5], [13.5, 12, 11.5, 4.5, 12], [14.5, 12.5, 12, 4.75, 12.5], [15, 13, 12.5, 5, 13]]),
      T('Bottom', SET_BOT3, M4.concat(Y4), [[21, 6.5, 7.5], [22, 7, 8], [23, 7, 8], [24, 7.5, 8.5], [26, 8.5, 13.35], [26.5, 9, 13.5], [27, 9.3, 14.5], [27.5, 9.5, 15]]) ] },
    bottom_girl: { title: 'Girls Bottom', fit: '', note: NOTE_X, tables: [
      T('', ['Waist', 'Hip', 'Length', 'Inseam'], M4.concat(Y4),
        [[18, 22, 8, 7.5], [19, 23, 8.5, 7.5], [20, 23, 9, 7.5], [21, 24, 9.5, 8], [21, 25, 20, 8.5], [22, 25, 22, 8.5], [23, 26, 24, 9], [24, 28, 26, 10]]) ] }
  };

  /* ---- Body measurements (workbook), aligned to the same age groups; inches ---- */
  var HB = ['Chest', 'Waist', 'Shoulder'];
  var HB4 = ['Chest', 'Waist', 'Hip', 'Shoulder'];
  var B_BOY4 = [[18, 17, 7.5], [18.5, 18, 7.8], [19.7, 19, 8.3], [20.9, 20.1, 8.8]];
  var B_GIRL4 = [[18, 17, 7], [18.5, 18, 8], [19, 18.5, 8.5], [20, 19, 9]];
  var B_BOY4H = [[18, 17, 18.1, 7.5], [18.5, 18, 18.9, 7.8], [19.7, 19, 20.1, 8.3], [20.9, 20.1, 21.3, 8.8]];
  var B_GIRL4H = [[18, 17, 20, 7], [18.5, 18, 21, 8], [19, 18.5, 21.5, 8.5], [20, 19, 22, 9]];
  var BODY = {
    tshirt_boy: T('', HB, M4, B_BOY4), sweatshirt_boy: T('', HB, M4, B_BOY4), jacket_boy: T('', HB, M4, B_BOY4),
    tshirt_girl: T('', HB, M4, B_GIRL4), top_girl: T('', HB, M4, B_GIRL4), jacket_girl: T('', HB, M4, B_GIRL4),
    shirt_boy: T('', HB, M4.concat(Y4), [[18, 17, 7.5], [18.5, 18, 7.8], [19.7, 19, 8.3], [20.9, 20.1, 8.8], [21, 20.5, 9], [22, 22, 9], [24, 23, 9.5], [26, 25, 10]]),
    pant_boy: T('', ['Waist', 'Hip'], M4, [[17, 18.1], [18, 18.9], [19, 20.1], [19.5, 21.3]]),
    shorts_boy: T('', ['Waist', 'Hip'], M4, [[17, 18.1], [18, 18.9], [19, 20.1], [20.1, 21.3]]),
    winterpant_girl: T('', ['Waist', 'Hip'], M4, [[17, 20], [18, 21], [19, 21.5], [20, 22]]),
    shorts_girl: T('', ['Waist', 'Hip'], M4.concat(Y4), [[17, 20], [18, 21], [19, 21.5], [20, 22], [21, 21.5], [22, 21.7], [23, 22], [23.5, 23]]),
    bottom_girl: T('', ['Waist', 'Hip'], M4.concat(Y4), [[17, 20], [18, 21], [19, 21.5], [20, 22], [21, 21.5], [22, 21.7], [23, 22], [23.5, 23]]),
    dress_girl: T('', ['Bust', 'Waist', 'Hip', 'Shoulder'], M4, B_GIRL4H),
    dungaree_boy: T('', HB4, M4, B_BOY4H), romper: T('', HB4, M4, B_BOY4H),
    dungaree_girl: T('', HB4, M4, B_GIRL4H),
    bodysuit: T('', HB4, ['0-3M', '3-6M', '6-9M', '9-12M', '12-18M'], [[18, 17, 18.1, 7.5], [18.5, 18, 18.9, 7.8], [19.7, 19, 20.1, 8.3], [20.9, 20.1, 21.3, 8.8], [21, 20.5, 21.5, 9]]),
    set2_boy: T('', HB4, M4, B_BOY4H), set3_boy: T('', HB4, M4, B_BOY4H), fullsuit_boy: T('', HB4, M4, B_BOY4H),
    set_girl: T('', HB4, M4.concat(Y4), [[18, 17, 20, 7], [18.5, 18, 21, 8], [19, 18.5, 21.5, 8.5], [20, 19, 22, 9], [20, 19, 24, 9], [22, 21, 25, 10], [23, 22, 25.5, 11], [24, 23, 26, 12]])
  };
  /* Typical height range per age group, cm (standard growth reference; used only by the recommender) */
  var HEIGHT = { '0-3M': [50, 60], '3-6M': [60, 68], '6-9M': [68, 72], '9-12M': [72, 76], '0-6M': [50, 68], '6-12M': [68, 76],
    '12-18M': [76, 83], '18-24M': [83, 90], '2Y': [90, 98], '3Y': [98, 105], '4Y': [105, 112], '5Y': [112, 118] };

  /* Gender priority: product type > tags > title. Unisex (both or neither) falls back to boys. */
  function isGirl(type, title, tags) {
    var G = /\bgirls?\b/, B = /\bboys?\b/;
    if (G.test(type)) return true;
    if (B.test(type)) return false;
    var gT = G.test(tags), bT = B.test(tags);
    if (gT !== bT) return gT;
    var gN = G.test(title), bN = B.test(title);
    if (gN !== bN) return gN;
    return false;
  }

  /* Returns chart key or null */
  function resolve(type, title, tags) {
    var t = (type || '').toLowerCase();
    title = (title || '').toLowerCase();
    tags = (tags || '').toLowerCase();
    var s = title + ' ' + tags;
    var girl = isGirl(t, title, tags);

    if (/bag|gift/.test(t)) return null;
    if (/dungaree/.test(t)) return girl ? 'dungaree_girl' : 'dungaree_boy';
    if (/romper|onesie/.test(t)) return /bodysuit|onesie/.test(s) ? 'bodysuit' : 'romper';
    if (/dress|frock/.test(t)) return 'dress_girl';
    if (/jacket|blazer/.test(t)) return girl ? 'jacket_girl' : 'jacket_boy';
    if (/sweatshirt|hoodie/.test(t)) return 'sweatshirt_boy';
    if (/set|pcs|pack/.test(t)) {
      if (girl) return 'set_girl';
      if (/suit/.test(s)) return 'fullsuit_boy';
      if (/3 pcs|3pcs|3 pc|three/.test(t + ' ' + s)) return 'set3_boy';
      return 'set2_boy';
    }
    if (/\bshirt\b/.test(t) && !/t-shirt|tshirt/.test(t)) return 'shirt_boy';
    if (/t-shirt|tshirt/.test(t)) return girl ? 'tshirt_girl' : 'tshirt_boy';
    if (/top/.test(t)) return 'top_girl';
    if (/bottom|lower|legging|pant|short/.test(t)) {
      if (girl) { if (/short/.test(s)) return 'shorts_girl'; return /winter|pant|trouser|jogger/.test(s) ? 'winterpant_girl' : 'bottom_girl'; }
      return /short/.test(s) ? 'shorts_boy' : 'pant_boy';
    }
    return null;
  }

  function fmt(v, unit) {
    if (v == null) return '\u2013';
    var n = unit === 'cm' ? v * 2.54 : v;
    n = Math.round(n * 10) / 10;
    return String(n);
  }
  function norm(s) { return s.replace(/\s+/g, '').toUpperCase(); }
  function isMobile() { return window.matchMedia && window.matchMedia('(max-width: 767px)').matches; }

  /* Desktop: sizes down, measurements across. Mobile: transposed — sizes across, measurements down. */
  function tableHtml(tb, unit, sel) {
    var h = tb.label ? '<h4 class="bsc-sub">' + tb.label + '</h4>' : '';
    if (isMobile()) {
      h += '<div class="bsc-tablewrap"><table class="bsc-table is-flipped"><thead><tr><th>Size</th>';
      tb.rows.forEach(function (r) { h += '<th' + (sel && norm(r[0]) === sel ? ' class="is-selected"' : '') + '>' + r[0] + '</th>'; });
      h += '</tr></thead><tbody>';
      tb.cols.forEach(function (c, i) {
        h += '<tr><td>' + c + '</td>';
        tb.rows.forEach(function (r) { h += '<td' + (sel && norm(r[0]) === sel ? ' class="is-selected"' : '') + '>' + fmt(r[1][i], unit) + '</td>'; });
        h += '</tr>';
      });
      return h + '</tbody></table></div>';
    }
    h += '<div class="bsc-tablewrap"><table class="bsc-table"><thead><tr><th>Size</th>';
    tb.cols.forEach(function (c) { h += '<th>' + c + '</th>'; });
    h += '</tr></thead><tbody>';
    tb.rows.forEach(function (r) {
      h += '<tr' + (sel && norm(r[0]) === sel ? ' class="is-selected"' : '') + '><td>' + r[0] + '</td>';
      r[1].forEach(function (v) { h += '<td>' + fmt(v, unit) + '</td>'; });
      h += '</tr>';
    });
    return h + '</tbody></table></div>';
  }

  function render(drawer) {
    var chart = CHARTS[drawer.dataset.chart];
    if (!chart) return;
    var unit = drawer.dataset.unit || 'inch';
    var sel = norm(drawer.dataset.selected || '');
    var mode = drawer.dataset.mode || 'garment';
    var body = BODY[drawer.dataset.chart];
    var h = '';
    if (mode === 'body' && body) h = tableHtml(body, unit, sel);
    else chart.tables.forEach(function (tb) { h += tableHtml(tb, unit, sel); });
    drawer.querySelector('[data-bsc-table]').innerHTML = h;
    drawer.querySelectorAll('[data-bsc-mode]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.bscMode === mode); b.disabled = (b.dataset.bscMode === 'body' && !body); });
    drawer.querySelector('[data-bsc-title]').textContent = chart.title;
    var fit = drawer.querySelector('[data-bsc-fit]');
    if (fit) { fit.textContent = chart.fit || ''; fit.hidden = !chart.fit; }
    drawer.querySelectorAll('[data-bsc-unit]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.bscUnit === unit); });
    drawer.querySelector('[data-bsc-unitnote]').textContent =
      'All measurements in ' + (unit === 'cm' ? 'centimetres' : 'inches') + '. ' +
      (mode === 'body' ? 'Body measurements are the child\u2019s own \u2014 choose the size whose figures are closest to or just above theirs.' : chart.note);
    var cu = drawer.querySelector('[data-bsc-chest-unit]'); if (cu) cu.textContent = unit === 'cm' ? 'cm' : 'in';
    var ageSel = drawer.querySelector('[data-bsc-age]');
    if (ageSel && ageSel.dataset.for !== drawer.dataset.chart) {
      ageSel.dataset.for = drawer.dataset.chart;
      var opts = '<option value="">Select age</option>';
      chart.tables[0].rows.forEach(function (r) { opts += '<option value="' + r[0] + '">' + r[0].replace('M', ' months').replace('Y', ' years') + '</option>'; });
      ageSel.innerHTML = opts;
    }
  }

  /* ---- Size recommender: age, height (cm) and/or chest; sizes up when inputs fall between sizes ---- */
  function recommend(drawer) {
    var chart = CHARTS[drawer.dataset.chart], body = BODY[drawer.dataset.chart];
    var sizes = chart.tables[0].rows.map(function (r) { return r[0]; });
    var unit = drawer.dataset.unit || 'inch';
    var age = drawer.querySelector('[data-bsc-age]').value;
    var height = parseFloat(drawer.querySelector('[data-bsc-height]').value);
    var chest = parseFloat(drawer.querySelector('[data-bsc-chest]').value);
    if (chest && unit === 'cm') chest = chest / 2.54;
    var out = drawer.querySelector('[data-bsc-result]');
    var picks = [];
    if (age) picks.push(sizes.indexOf(age));
    if (height) {
      var hi = -1;
      sizes.forEach(function (s, i) { var r = HEIGHT[s]; if (r && height >= r[0] && height < r[1]) hi = i; });
      if (hi < 0) { var last = HEIGHT[sizes[sizes.length - 1]], first = HEIGHT[sizes[0]]; if (last && height >= last[1]) hi = -2; else if (first && height < first[0]) hi = 0; }
      if (hi === -2) { out.textContent = 'This style runs up to ' + sizes[sizes.length - 1] + ' \u2014 ' + Math.round(height) + ' cm is above that range.'; out.hidden = false; return; }
      if (hi >= 0) picks.push(hi);
    }
    if (chest && body) {
      var ci = body.cols.indexOf('Chest'); if (ci < 0) ci = body.cols.indexOf('Bust');
      if (ci >= 0) {
        var bi = -1;
        for (var i = 0; i < body.rows.length; i++) { if (body.rows[i][1][ci] >= chest) { bi = i; break; } }
        if (bi < 0) { out.textContent = 'A chest of ' + fmt(chest, unit) + ' ' + (unit === 'cm' ? 'cm' : 'in') + ' is above the largest size in this style (' + sizes[sizes.length - 1] + ').'; out.hidden = false; return; }
        picks.push(bi);
      }
    }
    if (!picks.length) { out.textContent = 'Enter an age, height or chest to get a recommendation.'; out.hidden = false; return; }
    var idx = Math.max.apply(null, picks);
    var size = sizes[idx];
    var why = picks.length > 1 && idx !== Math.min.apply(null, picks) ? ' We sized up because your inputs fall between sizes.' : '';
    out.innerHTML = 'Recommended size: <strong>' + size + '</strong>.' + why + (idx < sizes.length - 1 ? ' If your child is at the top of the range or you want room to grow, choose ' + sizes[idx + 1] + '.' : '');
    out.hidden = false;
    drawer.dataset.selected = size;
    render(drawer);
    var row = drawer.querySelector('.is-selected'); if (row && row.scrollIntoView) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function currentSize(drawer) {
    var section = drawer._bscWrap || document;
    var fs = section.querySelector('fieldset.is-style-size [update-value]');
    return fs ? fs.textContent.trim() : '';
  }
  function open(drawer) {
    drawer.dataset.selected = currentSize(drawer);
    render(drawer);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bsc-lock');
    var c = drawer.querySelector('[data-bsc-close]'); if (c) c.focus();
  }
  function close(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bsc-lock');
  }

  function init(drawer) {
    if (drawer.dataset.bscInit) return;
    drawer.dataset.bscInit = '1';
    var key = resolve(drawer.dataset.type, drawer.dataset.title, drawer.dataset.tags);
    var wrap = drawer.closest('.hdt-product__variant-picker') || document;
    var btns = wrap.querySelectorAll('[data-bsc-open]');
    if (!key) { btns.forEach(function (b) { b.hidden = true; }); return; }
    drawer.dataset.chart = key;
    drawer._bscWrap = wrap;
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
    btns.forEach(function (b) {
      b.hidden = false;
      b.addEventListener('click', function (e) { e.preventDefault(); open(drawer); });
    });
    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bsc-close],[data-bsc-unit],[data-bsc-mode],[data-bsc-find],[data-bsc-toggle-finder]');
      if (!t) { if (e.target === drawer) close(drawer); return; }
      if (t.hasAttribute('data-bsc-close')) return close(drawer);
      if (t.hasAttribute('data-bsc-find')) return recommend(drawer);
      if (t.hasAttribute('data-bsc-toggle-finder')) { var f = drawer.querySelector('[data-bsc-finder]'); f.hidden = !f.hidden; t.setAttribute('aria-expanded', String(!f.hidden)); t.classList.toggle('is-open', !f.hidden); return; }
      if (t.hasAttribute('data-bsc-mode')) { drawer.dataset.mode = t.dataset.bscMode; return render(drawer); }
      drawer.dataset.unit = t.dataset.bscUnit; render(drawer);
    });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.closest('[data-bsc-finder]')) { e.preventDefault(); recommend(drawer); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(drawer); });
    var rt; window.addEventListener('resize', function () {
      clearTimeout(rt); rt = setTimeout(function () { if (drawer.classList.contains('is-open')) render(drawer); }, 150);
    });
  }

  function boot() { document.querySelectorAll('[data-bloomup-size-chart]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.BloomupSizeChart = { charts: CHARTS, body: BODY, resolve: resolve, boot: boot };
})();
